import { Grid, styled } from '@mui/material'

export const Wrapper = styled(Grid)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '4px 24px',
  backgroundColor: '#F8F8F8',
  [theme.breakpoints.down('md')]: {
    padding: '4px 24px'
  }
}))
